export const SOFTLINE_API_SCAN_LAGERPLATZ = "/v1/lagerplatzinhalt/scan-lagerplatz/{{code}}";
export const SOFTLINE_API_LAGERKORREKTUR_ARTIKEL = '/v1/lagerkorrektur-artikel';
export const SOFTLINE_API_UMBUCHUNGSARTIKEL = '/v1/umbuchungsartikel/entities';
